import * as React from 'react';
import { Button, buttonType } from 'components/button/button';
// import ReactCodeInput from "react-verification-code-input";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { ReactComponent as LeftArray } from 'assets/icons/signin/left-array.svg';
import './code.scss';
import { ToEn } from 'core/utils/decimalExtentions';
import { getViaAuth, postGeneric, responseValidator } from 'apis/api';
import { API } from 'apis';
import { LoginResult } from '../login-with-password/login-with-passowrd';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import OtpInput from 'react-otp-input';

interface Props {}

export const Code: React.FC<Props> = () => {
    const [codeValue, setCodeValue] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>();
    const [error, setError] = React.useState<string>('');

    const navigate = useNavigate();

    const phone = localStorage.getItem('phone') || '';

    function confirmCode(code: string) {
        setLoading(true);
        postGeneric<LoginResult>(API.general.verify2fa, {
            platformType: 1,
            phoneNumber: phone,
            code: code,
        })
            .then(async (res) => {
                setLoading(false);
                if (responseValidator(res.status)) {
                    res.value?.accessToken && localStorage.setItem('accessToken', res.value?.accessToken);
                    res.value?.refreshToken && localStorage.setItem('refresh', res.value?.refreshToken);
                    localStorage.setItem('date', moment.utc().toString());
                    res.value?.expiresIn && localStorage.setItem('expiresIn', res.value?.expiresIn.toString());
                    localStorage.setItem('isAuthorized', res.value?.isAuthorized.toString());
                    localStorage.setItem('level', res.value?.isTwoFactorEnabled.toString());
                    res.value?.roles && localStorage.setItem('roles', res.value?.roles.join(','));
                    localStorage.setItem('tokenType ', res.value?.tokenType);

                    await getViaAuth(API.roles.getMineMenuItems).then((res: any) => {
                        if (responseValidator(res.status)) {
                            res.data && localStorage.setItem('menuItems', JSON.stringify(res?.data));
                        }
                    });

                    navigate('/dashboard/users');
                }
            })
            .catch((err) => {
                navigate('/signin');
            });
    }

    return (
        <div className="code">
            <LeftArray onClick={() => navigate('/signin')} />
            <div className="title">
                <p>کد تایید 2 مرحله‌ای را وارد کنید</p>
            </div>

            <div className="signin-code-main code">
                <OtpInput
                    renderInput={(props) => <input {...props} />}
                    value={codeValue}
                    onChange={(value) => setCodeValue(ToEn(value))}
                    numInputs={6}
                    shouldAutoFocus
                    inputStyle={'pmx-otp-input'}
                    containerStyle={'pmx-otp-input-container'}
                />

                <div className="signin-code-stats">
                    <div className="signin-code-errors">
                        {error ? (
                            <>
                                <QuestionCircleOutlined />
                                <span>{error}</span>
                            </>
                        ) : (
                            <span></span>
                        )}
                    </div>

                    {!error && <span></span>}
                </div>
            </div>
            <Button
                disabled={codeValue.length != 6}
                type={buttonType.info}
                loading={loading}
                text="تایید"
                onClick={() => confirmCode(codeValue)}
            />
            <div className="footer-text">
                <p>
                    شماره وارد شده متعلق به شما نیست؟ <span onClick={() => navigate('/signin')}>تصحیح شماره</span>
                </p>
            </div>
        </div>
    );
};
